import { Selector, dataBindingType } from '@common/constants/shared';
import { isEmpty } from 'lodash';

export const getSourceDataBinding = (obj: any): any => {
  if (isEmpty(obj)) return {};

  let res: any = {};
  for (var k in obj) {
    const value = obj[k];
    if (dataBindingType.includes(k) && value?.type === 'binding') {
      res = value;
    } else if (typeof value === 'object') {
      res = { ...res, ...getSourceDataBinding(value) };
    }
  }
  return res;
};
/** Reduce values with key in the ids props. */
export const reduceValuesWithIds = (ids: string[]) => (values: any) => {
  if (!ids.length) return;
  return ids.reduce((preValue: any, current: string) => {
    const currentValue = values[current];
    return {
      ...preValue,
      ...(currentValue && {
        [current]: currentValue,
      }),
    };
  }, {});
};

/**
 * Traverse the object.
 * @param obj - The object to traverse.
 * @param callback - The callback with child object.
 * */
export const traverseObject = (obj: any, callback: (child: any) => void) => {
  // Array
  if (Array.isArray(obj)) {
    for (let index = 0; index < obj.length; index++) {
      const child = obj[index];
      traverseObject(child, callback);
    }
    return;
  }
  // None object
  if (!obj || typeof obj !== 'object') {
    return obj;
  }

  for (const key in obj) {
    traverseObject(obj[key], callback);
  }

  callback(obj);
};

/**
 * Recursively extracts the ids (routeParams and inputIds) of the dependencies (routeParams and inputIds) from the object.
 * @param obj - The object to traverse.
 * @returns Array routeParams and array inputIds.
 */
export const extractDependenciesFromObject = (
  obj: any
): { routeParams: string[]; inputIds: string[] } => {
  const inputIds: Set<string> = new Set();
  const routeParams: Set<string> = new Set();

  traverseObject(obj, (child) => {
    if (
      child?.selector?.type === Selector.ROUTE_PARAM_SELECTOR &&
      typeof child?.tableId === 'string'
    )
      routeParams.add(child?.tableId);
    if (typeof child?.objectId === 'string') inputIds.add(child?.objectId);
    if (typeof child?.selectObjectId === 'string')
      inputIds.add(child?.selectObjectId);
  });

  return {
    routeParams: Array.from(routeParams),
    inputIds: Array.from(inputIds),
  };
};
